<template>
  <div class="px-2">
    <px-aprovacao-compra-produtos-table :aprovacao="aprovacao"
                                        @update="emitUpdate"/>
  </div>
</template>

<script>
import AprovacaoCompraProdutosTable
  from '@/modules/aprovacao-compra/components/AprovacaoCompraProdutosTable.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitUpdate(item) {
      this.$emit('update', item);
    },
  },
  components: {
    pxAprovacaoCompraProdutosTable: AprovacaoCompraProdutosTable,
  },
};
</script>
